const BaseUrl="https://linkup.logicspice.com/linkup/public/api/";
// const BaseUrl="http://192.168.1.16:8000/api/";
export default BaseUrl;